import React from 'react';
import styled from 'styled-components';

import { useArtistFundraisingPickNewMarketsRollout } from '../../../utils';
import { DialogBodyProps } from '../../types';
import { DialogWrapper } from '../DialogWrapper';
import { FormInputAside } from './FormInputAside';
import { Headings } from './Headings';
import { InputGroup } from './InputGroup';
import { RadioGroup } from './RadioGroup';

import { DEPRECATEDInputGroup } from './__deprecated__/DEPRECATEDInputGroup';
import { DEPRECATEDRadioGroup } from './__deprecated__/DEPRECATEDRadioGroup';

const RadioInputsWrapper = styled.div`
  flex-basis: 100%;
  flex-grow: 1;
  position: relative;
`;

export function FormInput(props: DialogBodyProps) {
  return (
    <DialogWrapper>
      <RadioInputsWrapper>
        <Headings isEditing={props.isEditing} />

        <RadioInputs {...props} />
      </RadioInputsWrapper>

      <FormInputAside />
    </DialogWrapper>
  );
}

function RadioInputs(props: DialogBodyProps) {
  const [
    isFundraisingLinkSelected,
    setIsFundraisingLinkSelected,
  ] = React.useState(true);
  // Design updates to improve the user experience for new markets
  //
  // Adding a fundraising link
  //
  // For new markets support, adding a fundraising link involves selecting an
  // <option> for "Fundraising link", then choosing a payment provider in a
  // <select>, then finally entering a fundraising link in a <input type="text">
  //
  // Previously, entering a fundraising link involved choosing a payment
  // provider in a <select>, then finally entering a fundraising link in an
  // <input type="text">
  const isNewMarketsRolledOut = useArtistFundraisingPickNewMarketsRollout();

  if (isNewMarketsRolledOut) {
    return (
      <>
        <RadioGroup
          {...props}
          isFundraisingLinkSelected={isFundraisingLinkSelected}
          setIsFundraisingLinkSelected={setIsFundraisingLinkSelected}
        />
        <InputGroup
          {...props}
          isFundraisingLinkSelected={isFundraisingLinkSelected}
          setIsFundraisingLinkSelected={setIsFundraisingLinkSelected}
        />
      </>
    );
  }

  return (
    <>
      <DEPRECATEDRadioGroup {...props} />
      <DEPRECATEDInputGroup {...props} />
    </>
  );
}
